import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { NewAssetForm } from "pages/asset/forms/new-form";
import Dialog from "components/dialog";
import { updateNewShieldEventFile } from "../../../../../services/commonService";

const useStyles = makeStyles(() => ({
  shieldContainer: {
    overflowY: "visible",
  },
}));

export default function DialogNewShieldOnEvent({
  intl,
  customerIdSelected,
  openDialogNewShield,
  handleCloseDialogNewShield,
  asset,
  handleChange,
  handleAssetUpload,
  assetPath,
  assetFormDisabled,
  team,
}) {
  const [submitNewShield, setSubmitNewShield] = useState(false);
  const classes = useStyles();

  const handleUpdateNewShield = data => {
    if (data && data._id) {
      handleCloseDialogNewShield();
      handleChange(`sportEventData.teamLogoAsset${team}`)("");
      handleChange(`sportEventData.teamLogo${team}`)(data._id);
    }
  };

  const handleUpload = () => {
    updateNewShieldEventFile({ body: { file: asset }, customerId: customerIdSelected }, handleUpdateNewShield);
  };

  useEffect(() => {
    return () => {
      setSubmitNewShield(false);
    };
  }, []);

  return (
    <Dialog
      contentClassName={classes.shieldContainer}
      onClose={handleCloseDialogNewShield}
      aria-labelledby="customized-dialog-title"
      open={openDialogNewShield}
      showModalAccept
      showModalClose
      onAccept={handleUpload}
      title={intl.formatMessage({ id: "event.asset.newshield" })}
    >
      <NewAssetForm
        customerIdSelected={customerIdSelected}
        submitNewShield={submitNewShield}
        disabled={assetFormDisabled}
        disabledCategorySelection
        onChange={handleChange}
        onImageChange={handleAssetUpload}
        values={asset}
        path={`${assetPath}.`}
        acceptImage={["image/png"]}
        allowedAssetTypes={["image"]}
        defaultCategories={["TEAM_SHIELD"]}
      />
    </Dialog>
  );
}
